import { toast, cssTransition } from "react-toastify";

const fade = cssTransition({
  collapse: false,
  enter: "fade-in",
  exit: "fade-out",
});

interface Options {
  timeout?: number;
}

export function showToast(message: string, options?: Options) {
  toast(message, {
    autoClose: options?.timeout ?? 3000,
    closeButton: false,
    draggable: false,
    hideProgressBar: true,
    position: "top-center",
    transition: fade,
  });
}
